export const registrationRoutes = {
  main: "",
} as const;
